import React, { useState } from "react";
import { Button, PageHeader, Descriptions, Tabs, Space, Tag, Layout } from "antd";
import { useQuery } from "@apollo/react-hooks";
import { GetOrg, OrgGql } from "../../graphql/organization";
import { OrgDlg } from "./components/OrgDlg";
import { useParams, Route, useHistory, Switch } from "react-router-dom";
import { BankOutlined, WalletOutlined } from "@ant-design/icons";
import { OrgDashboard } from "./OrgDashboard";
import { OrgStudents } from "./OrgStudents";
import { OrgImport } from "./OrgImport";
import { OrgMembers } from "./OrgMembers";
import { OrgTeachers } from "./OrgTeachers";
import { OrgFundraisings } from "./OrgFundraisings";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";
import { CommunityStatusNames } from "../../store/community/CommunitiesStore";
const { TabPane } = Tabs;

export const Org = observer(() => {
  let { id, tab = "" } = useParams<any>();
  const store = Store.orgsStore.orgView;
  store.active(id);
  console.log(id, tab);
  const {} = useQuery(OrgGql.gradeList);
  const { loading, data: { org } = { org: { id } }, refetch } = useQuery<any>(GetOrg, { variables: { id } });
  const [showSubDlg, setShowSubDlg] = useState(false);
  const [showEditDlg, setShowEditDlg] = useState(false);
  const [model, setModel] = useState({ id: null });

  const [activing, setActiving] = useState(false);
  const history = useHistory();

  const editSub = (m) => {
    setModel(m);
    setShowSubDlg(true);
  };

  const onTab = (key) => {
    history.push(`/orgs/${id}/${key}`);
  };

  return (
    <Layout>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={org?.name}
        tags={
          <Space>
            {org?.isCommunity && (
              <Tag icon={<BankOutlined />} color="green">
                Community
              </Tag>
            )}
            {org?.isSchool && (
              <Tag icon={<BankOutlined />} color="blue">
                School
              </Tag>
            )}
            {org?.canFund && (
              <Tag icon={<WalletOutlined />} color="gold">
                Fundraising
              </Tag>
            )}
          </Space>
        }
        extra={[
          Store.isDivision ? null : (
            <Button size="small" key="3" onClick={() => store.edit()}>
              Edit
            </Button>
          ),
        ]}
        footer={
          <Tabs
            activeKey={tab}
            onChange={onTab}
            onTabClick={(key) => {
              console.log(key);
              if (key === "add") {
                editSub({ orgId: id });
              }
            }}
          >
            <TabPane tab="Dashboard" key="" />
            <TabPane tab="User" key="members" />
            <TabPane tab="Teacher" key="teachers" />
            <TabPane tab="Student" key="students" />
            {!Store.isDivision && org?.canFund && <TabPane tab="Fundraising Organization" key="fundraising" />}{" "}
            {!Store.isDivision && <TabPane tab="Import Data" key="import" />}
          </Tabs>
        }
      >
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="Division">{org?.division?.name}</Descriptions.Item>
          <Descriptions.Item label="State">{org?.state}</Descriptions.Item>
          <Descriptions.Item label="City">{org?.city}</Descriptions.Item>
          <Descriptions.Item label="Community Name" span={1}>
            {org?.community?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Community Status" span={1}>
            {org?.community?.status ? CommunityStatusNames[org?.community?.status] : "-"}
          </Descriptions.Item>
        </Descriptions>
      </PageHeader>

      <Layout.Content className="padding24">
        <Switch>
          <Route path="/orgs/:id" exact component={OrgDashboard} />
          <Route path="/orgs/:id/members" component={OrgMembers} />
          <Route path="/orgs/:id/students" component={OrgStudents} />
          <Route path="/orgs/:id/teachers" component={OrgTeachers} />
          <Route path="/orgs/:id/import" component={OrgImport} />
          <Route path="/orgs/:id/fundraising" component={OrgFundraisings} />
        </Switch>
      </Layout.Content>
      {store.orgsStore.orgEdit.visible && <OrgDlg />}
    </Layout>
  );
});
